import { render, staticRenderFns } from "./ProjectAddition.vue?vue&type=template&id=0d45f867&scoped=true&"
import script from "./ProjectAddition.vue?vue&type=script&lang=js&"
export * from "./ProjectAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45f867",
  null
  
)

export default component.exports